import React, { useState, useEffect } from "react";
import {
  Button,
  message,
  Tabs,
  Table,
  Calendar,
  Modal,
  Form,
  Input,
  Switch,
  Select,
} from "antd";
import { useSelector } from "react-redux";
import { _get, _post, _postnew, _put } from "../../../Utils/Helper";
import { RootState } from "../../../../redux/reducers";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import { all_routes } from "../../../router/all_routes";

const ParentChildren: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const [teacherData, setTeacherData] = useState<any>(null);
  const [childrenList, setChildrenList] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState("1");
  const [showSaturday, setShowSaturday] = useState(false);
  const [selectedChildren, setSelectedChildren] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [attendanceList, setAttendanceList] = useState<any[]>([]);
  const [mode, setMode] = useState<"check-in" | "check-out" | null>(null);

  // Fetch teacher details
  useEffect(() => {
    if (user?.id) {
      _get(
        `get-parent?query_type=childlist&id=${user?.id}`,
        (result) => {
          if (result.success && result.results.length > 0) {
            setChildrenList(result.results);
            // message.success("Children fetched successfully.");
          }
        },
        (err) => {} // message.error("Failed to fetch children data.")
      );
    }
  }, []);
  useEffect(() => {
    if (selectedChildren.length > 0) {
     
      _get(
        `students/attendance?query_type=select-student&admission_no=${selectedChildren}`,
        (data) => {
          if (data.success && data.data.length > 0) {
            setAttendanceList(data.data);
            // console.log(data);
          } else {
            // message.error("Invalid attendance data format received.");
          }
        },
        (err) => {} // message.error("Failed to fetch attendance data.")
      );
    }
  }, [selectedChildren]);

  const routes = all_routes;

  const columns = [
    {
      title: "Admission No",
      dataIndex: "admission_no",
      render: (text: string, record: any, index: number) => (
        <Link
          to={`${routes.studentDetail}?admission_no=${record.admission_no}`}
          className="link-primary"
        >
          {text}
        </Link>
      ),
    },
    {
      title: "Student Name",
      dataIndex: "student_name",
      render: (text: string, record: any, index: number) => (
        <div className="d-flex align-items-center">
          {record.profile_picture ? (
            <Link to="#" className="avatar avatar-md">
              <ImageWithBasePath
                src={record.profile_picture}
                className="img-fluid rounded-circle"
                alt="img"
              />
            </Link>
          ) : null}
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link
                to={`${routes.studentDetail}?admission_no=${record.admission_no}`}
                className="link-primary"
              >
                {text}
              </Link>
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Current Class",
      dataIndex: "current_class",
    },
    {
      title: "Gender",
      dataIndex: "sex",
    },
    {
      title: "DOB",
      dataIndex: "date_of_birth",
    },
  ];

  const checkLocation = () => {
    const schoolLocation = teacherData?.data?.school_location || {
      latitude: 40.7128,
      longitude: -74.006,
    };
    const mockUserLocation = { latitude: 40.7129, longitude: -74.0059 };

    const distance = calculateDistance(
      mockUserLocation.latitude,
      mockUserLocation.longitude,
      schoolLocation.latitude,
      schoolLocation.longitude
    );
    return distance <= 0.1;
  };

  const calculateDistance = (
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number
  ) => {
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={[
            {
              key: "1",
              label: "Children List",
              children: (
                <>
                  <Table
                    dataSource={childrenList}
                    columns={columns}
                    rowKey="id"
                    bordered
                  />
                </>
              ),
            },
            {
              key: "2",
              label: "Attendance Calendar",
              children: (
                <>
                <div className="d-flex justify-content-end">
                {/* <Switch
                    checked={showSaturday}
                    onChange={setShowSaturday}
                    checkedChildren="Show Saturday"
                    unCheckedChildren="Hide Saturday"
                  /> */}
                  <div className="mb-3 d-flex align-items-start" style={{ flexDirection: "column", width:"30%" }}>
                  <label className="form-label">Children</label>
                   <Select
                     style={{
                      width: "100%",
                      marginRight: "10px",
                    }}
                    onChange={(value) => setSelectedChildren(value)}
                    value={selectedChildren}
                    options={childrenList?.map((child) => ({
                      value: child.admission_no,
                      label: child.student_name,
                    }))}
                  />
                  </div>
                </div>
                {/* {JSON.stringify(attendanceList)} */}

                  
                <Calendar
                  dateCellRender={(value) => {
                   const date = value.format("YYYY-MM-DD");
                   const attendance = Array.isArray(attendanceList) 
                     ? attendanceList.find((item) => item.day === date) 
                     : null;

                  return attendance ? (
                  <div
                    style={{
                      backgroundColor: attendance.status === "Present" ? "#4caf50" : "#f44336",
                      color: "#fff",
                      padding: "5px",
                      borderRadius: "4px",
                      textAlign: "center",
                    }}
                      >
                      {attendance.status}
                  </div>
                    ) : null;
  }}
/>


                </>
                )
            }
           
          ]}
        />
      </div>
    </div>
  );
};

export default ParentChildren;
